import { createContext, useContext, useState } from "react";
import Toast from "../components/common/Toast";

const ToastContext = createContext();

export function ToastProvider({ children }) {

  const [toasts, setToasts] = useState([]);

  function showToast(message, type="info", duration=2000) {

    const id = Date.now();

    setToasts(prev => [
      ...prev,
      { id, message, type, duration }
    ]);

    setTimeout(() => {
      removeToast(id);
    }, duration);
  }

  function removeToast(id) {
    setToasts(prev => prev.filter(t => t.id !== id));
  }

  return (
    <ToastContext.Provider value={{ showToast }}>

      {children}

      <div className="toastContainer">
        {toasts.map(t => (
          <Toast
            key={t.id}
            toast={t}
            onClose={removeToast}
          />
        ))}
      </div>

    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}